import { useNavigate } from 'react-router';
import { PATHS } from '../../navigation';
import { t } from '../../theme';
import { useStore } from '../../store';
import { Widget, WidgetEmpty } from './Widget';

export function ShoppingWidget() {
  const shopping = useStore((s) => s.shopping);
  const navigate = useNavigate();

  const open = shopping.filter((i) => !i.done);

  return (
    <Widget
      kicker="EINKAUF"
      onTap={() => navigate(PATHS.shop)}
      accessory={
        open.length > 0 ? (
          <div style={{ fontFamily: t.mono, fontSize: 12, color: t.inkFaint, whiteSpace: 'nowrap' }}>
            {open.length} offen
          </div>
        ) : null
      }
    >
      {open.length === 0 ? (
        <WidgetEmpty>Nichts einzukaufen.</WidgetEmpty>
      ) : (
        <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8, overflow: 'hidden' }}>
          {open.slice(0, 6).map((i) => (
            <div
              key={i.id}
              style={{
                fontSize: 18,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: 'oklch(0.88 0.012 70)',
              }}
            >
              {i.name}
            </div>
          ))}
          {open.length > 6 && (
            <div style={{ fontSize: 15, color: t.inkFaint, marginTop: 2 }}>+{open.length - 6} weitere</div>
          )}
        </div>
      )}
    </Widget>
  );
}
